export default __webpack_public_path__ + "static/media/xbox-white.f4b6e98b.png";